import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import StyledButton from 'flaivy-react/components/StyledButton';

import Image from 'flaivy-react/components/Image';
import Link from 'next/link';

export interface CallToActionBlockProps {
  id?: string;
  title?: string;
  titleClassNames?: string;
  text?: string;
  textColor?: string;
  textClassNames?: string;
  backgroundImage?: string;
  backgroundColor?: string;
  image?: string;
  buttonText?: string;
  buttonLink?: string;
  buttonClassNames?: string;
  backGroundImageWidth?: number;
  backgroundImageHeight?: number;
  useVideo?: boolean;
  videoSrc?: string;
  useFixedBackgroundImage?: boolean;
}

function CallToActionBlock({
  block,
  className,
}: {
  block: CallToActionBlockProps;
  className?: string;
}) {
  return (
    <Container fluid className="h-100">
      <Row
        className={`justify-content-center align-items-center h-100 ${
          block.useVideo ? 'call-to-action-block-video' : 'call-to-action-block'
        } ${className}`}
        style={{
          backgroundImage:
            !block.useVideo && block?.backgroundImage
              ? `url(${block?.backgroundImage})`
              : 'none',
          backgroundColor: block?.backgroundColor
            ? block?.backgroundColor
            : 'transparent',
        }}
      >
        {block.useVideo && (
          <video
            src={block.videoSrc}
            autoPlay
            loop
            muted
            playsInline
            className="g-0"
          />
        )}
        <Col
          xs={12}
          className="align-items-center p-5"
          style={{
            position: block.useVideo ? 'absolute' : 'relative',
          }}
        >
          <Row className="justify-content-center align-items-center">
            {block?.image && (
              <Col xs={12} className="text-center mb-2">
                <Image
                  src={block?.image}
                  alt=".."
                  className="logo"
                  resX={200}
                  resY={85}
                />
              </Col>
            )}
            {block.title && (
              <Col
                xs={12}
                className="text-center text-bold d-flex justify-content-center"
              >
                <div
                  style={{ color: block?.textColor || 'white' }}
                  className={`call-to-action-block-inner ${
                    block.titleClassNames || 'h1'
                  }`}
                >
                  {block?.title}
                </div>
              </Col>
            )}
            {block.text && (
              <Col
                xs={12}
                className="text-center d-flex justify-content-center"
              >
                <div
                  style={{ color: block?.textColor || 'white' }}
                  className={`call-to-action-block-inner ${
                    block.textClassNames || 'h5'
                  }`}
                  dangerouslySetInnerHTML={{ __html: block?.text }}
                ></div>
              </Col>
            )}
            {block.buttonText && (
              <Col xs={12} className="text-center">
                <Link href={block?.buttonLink || '/'}>
                  <StyledButton
                    color="light"
                    className={block.buttonClassNames}
                  >
                    {block?.buttonText}
                  </StyledButton>
                </Link>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </Container>
  );
}
export default CallToActionBlock;
